import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import Spinner from '~/components/Spinner';

import { loadKeyStartRace } from './actions';
import { selectError, selectKeyStartRace, selectLoading } from './selectors';

const KeyStartRace = ({
  keyStartRace,
  race,
  render,
  loadKeyStartRace,
  loading,
  error,
}) => {
  useEffect(() => {
    if (!keyStartRace) {
      loadKeyStartRace(race);
    }
  }, [keyStartRace, loadKeyStartRace, race]);

  return (
    <Spinner loading={loading} error={error}>
      {keyStartRace && render(keyStartRace)}
    </Spinner>
  );
};

KeyStartRace.propTypes = {
  keyStartRace: PropTypes.object,
  race: PropTypes.number.isRequired,
  render: PropTypes.func.isRequired,
  loadKeyStartRace: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.object,
};

const mapStateToProps = (state, props) => ({
  loading: selectLoading(state, props),
  error: selectError(state, props),
  keyStartRace: props.selector
    ? props.selector(state, props)
    : selectKeyStartRace(state, props),
});

function mapDispatchToProps(dispatch) {
  return {
    loadKeyStartRace: race => dispatch(loadKeyStartRace(race)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(KeyStartRace);
